var React = require('react');

function BlockerFeatures (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Blocker Features","clipPath":"url(#clip0_97_121846)","key":0},React.createElement("path",{"id":"blockericon","fillRule":"evenodd","clipRule":"evenodd","d":"M33.3301 0L48.3301 15V33L33.3301 48H15.3301L0.330078 33V15L15.3301 0H33.3301ZM30.8401 5.99707H17.8171L14.1936 9.62053L38.7066 34.1335L42.3301 30.5101V17.4871L30.8401 5.99707ZM34.464 38.3762L9.95098 13.8632L6.33008 17.4841V30.5131L17.8141 41.9971H30.8431L34.464 38.3762Z","fill":"#8D6CFF"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_97_121846"},React.createElement("rect",{"width":"48","height":"48","fill":"white","transform":"translate(0.330078)"})))]);
}

BlockerFeatures.defaultProps = {"width":"49","height":"48","viewBox":"0 0 49 48","fill":"none"};

module.exports = BlockerFeatures;

BlockerFeatures.default = BlockerFeatures;
